import React, { useState } from 'react'

import { Box, Button, Card, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ReactComponent as NoEnergyContractsImage } from '../assets/noEnergyContracts.svg'

import useUpdatedCustomer from '~/core/hooks/useUpdatedCustomer'
import { ChangeEmailModal } from '~/customer/components'

const useStyles = makeStyles((theme) => {
  return {
    noEnergyContractsImage: {
      margin: theme.spacing(16),
    },
  }
})

const NoEnergyContracts: React.FC = () => {
  const classes = useStyles()
  const { onUpdateCustomer } = useUpdatedCustomer()

  const [isOpenChangeEmailModal, setIsOpenChangeEmailModal] = useState(false)

  const changeEmailModalOnClose = (emailHasChanged: boolean) => {
    setIsOpenChangeEmailModal(false)
    if (emailHasChanged) {
      onUpdateCustomer()
    }
  }

  return (
    <Box width="100%" p={9} data-hook="no-energy-contracts">
      <Card>
        <Box
          mb={16}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <NoEnergyContractsImage className={classes.noEnergyContractsImage} />
          <Typography variant="h2">Este cliente no tiene contrato de energía</Typography>
          <Box m={4} />
          <Button
            data-hook="new-energy-contract-button"
            variant="contained"
            color="secondary"
            onClick={() => setIsOpenChangeEmailModal(true)}
          >
            + Añadir contrato de energía
          </Button>
        </Box>
      </Card>
      {isOpenChangeEmailModal && (
        <ChangeEmailModal isOpen={isOpenChangeEmailModal} onClose={changeEmailModalOnClose} />
      )}
    </Box>
  )
}

export default NoEnergyContracts
